import {Types} from "../actions/shiftActions";
import _ from "lodash";

const defaultState = {
  shifts: {}
};

const shiftReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.SHIFTS_UPDATE_SHIFT: {
        let newState = _.cloneDeep(state);
        newState.shifts.current.shifts[action.field] = action.data
        return newState
    }
    default:
      return state;
  }
};

export default shiftReducers;